import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=0ce06d56&scoped=true&"
import script from "./Dates.vue?vue&type=script&lang=js&"
export * from "./Dates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce06d56",
  null
  
)

export default component.exports